module.exports = __webpack_public_path__ + "img/shipo-home-barge.9dd0eefe.svg";